import type { ModalProps } from '@chakra-ui/react';
import { ModalCloseButton, Text } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerBody,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';

export const LearnMoreDrawer = (props: Omit<ModalProps, 'children'>) => {
  const t = useTranslations();
  return (
    <ModalOrDrawer
      variant="wholeScreen"
      placement="bottom"
      scrollBehavior="inside"
      {...props}
    >
      <ModalOrDrawerOverlay bg="bg-gauze" />
      <ModalOrDragDrawerContent h={{ base: '60vh', desktop: undefined }}>
        <InDesktop>
          <ModalCloseButton />
        </InDesktop>
        <ModalOrDrawerHeader>{t('Learn more')}</ModalOrDrawerHeader>
        <ModalOrDrawerBody>
          <Text textStyle="h3" textAlign="center">
            {t('Watering Boost')}
          </Text>
          <Text textAlign="center" mt="42px" color="text-light">
            {t('watering-boost-desc-1')}
          </Text>
          <Text textAlign="center" mt="30px" color="text-light">
            {t('watering-boost-desc-2')}
          </Text>
        </ModalOrDrawerBody>
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
};
